import '../../../src/docReady.js';
import { getSlider } from 'simple-slider';
import Vimeo from '@vimeo/player';

import isMobile from '../../../src/isMobile.js';
import Easie from '../../../src/Easie.js'; // easing
import Helper from '../../../src/Helper.js'; // easing

const moduleSelector = '.component-image';

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo image');
    }

    // _________________________________________________________________________
    
    live(element, selector) {

        // Initialize results with current nodes.
        var result = Array.prototype.slice.call(element.querySelectorAll(selector));

        // Create observer instance.
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                [].forEach.call(mutation.addedNodes, function(node) {
                    if (node.nodeType === Node.ELEMENT_NODE && node.matches(selector)) {
                        result.push(node);
                    }
                });
            });
        });

        // Set up observer.
        observer.observe(element, { childList: true, subtree: true });

        return result;
    }

    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);
            
            // poly
            if (window.NodeList && !NodeList.prototype.forEach) {
                NodeList.prototype.forEach = Array.prototype.forEach;
            }

            // avvia il carousel per ogni modulo trovato
            if($modules && $modules.length > 0) {
                $modules.forEach(($module) => {
                    new ModuleFeature($module);
                });
            }
        });
    }
}

class ModuleFeature {
    
    constructor($module) {
        this.init_player($module);
    }

    // _________________________________________________________________________

    /**
     * Restituisce il dominio da un url
     * @param {type} url
     * @returns {nm$_module.module.exports.get_domain_by_url.domain|nm$_module.exports.get_domain_by_url.domain}
     */
    get_domain_by_url(url) {
        // ricava il player presente nel frame
        var domain = url.replace('http://','').replace('https://','').split(/[/?#]/)[0];
        
        return domain;
    }
    
    // _________________________________________________________________________
    
    /**
     * Inizializza il player in una slide
     * @param {type} $slide
     * @returns {undefined}
     */
    init_player($slide) {
        // Per ogni slide, verifica se ci sono player a cui collegare azioni di pausa dello slider nel caso di play
            
        // ottiene l'iframe
        var $iframe = $slide.querySelector('iframe');

        if($iframe !== null) {
            var url = $iframe.getAttribute('src');
            var domain = this.get_domain_by_url(url);
        }

        /**
         * Azioni differenti nel caso di video player
         * @param {type} message
         * @returns {undefined}
         */
        if(domain !== undefined) {
            switch(domain) {
                case 'player.vimeo.com':
                    this.init_player_vimeo($iframe);
                break;
            }
        }
    }
    
    // _________________________________________________________________________
    
    /**
     * Inizializza il player Vimeo
     * @param {type} $iframe
     * @returns {undefined}
     */
    init_player_vimeo($iframe) {
        // azioni nel caso di player vimeo
        var player = new Vimeo($iframe);
        
        this.config_player_vimeo(player);
    }
    
    // _________________________________________________________________________
    
    /**
     * Gestisce gli eventi del player Vimeo
     * @param {type} player
     * @returns {undefined}
     */
    config_player_vimeo(player) {
        var that = this;
        
        // Quando il video viene riprodotto
        // - lo slider va in pausa
        player.on('play', function() {
            that.Slider.pause();
        });

        // Quando il video viene riprodotto
        //  - lo slider riparte
        player.on('pause', function() {
            that.Slider.resume();
        });
    }

 
    // _________________________________________________________________________
}

// export
export default new Module();